var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, observable, observe, extendObservable, computed, ObservableMap } from "mobx";
import { EventsBySportIdRequest } from "sb-bff-integration";
import Debounce from "debounce-decorator";
import * as i from "../contracts";
import { EventModes, FilterPredicate, SubFilterPredicate } from "../data";
import { EmptyStatisticsData, StreamingFilterBlockConstant } from "../constants";
import { DateRangeMapper, compareArrays, mapStartDateTime, prepareMarkets, mapLinkUrl, mapLeagueUrl, mapIsSelected, mapSelectionsOdds, mapEventComponent, updateLeagueRankID, FavoritesManager, MessageBus, mapStatisticsIcon, mapMBNMarketIcon, OutrightSelectionSorter } from "../helpers";
import { mapKickOffTime } from "../composables/mappers";
import { sortLeagues } from "../composables/sorters";
export class Parser {
    constructor(retriever, piper, requstParams, navFunctions, specialLeagues, parserCmsConfig, dict, favoritesManager) {
        this.piper = piper;
        this.retriever = retriever;
        this.dict = dict;
        this.topicPrefix = `${parserCmsConfig.topicPrefix}.`;
        this.clientId = parserCmsConfig.clientId;
        this.eventsCountBySport = {};
        this.eventsDisposers = [];
        this.loaderDisposers = [];
        this.markets = observable([]);
        this.events = observable([]);
        this.sports = requstParams.sportIds;
        this.dateRange = requstParams.dateRange;
        this.allSportIds = requstParams.allSportIds;
        this.isFavoritesEnabled = retriever.dataProvider.isFavoritesEnabled;
        this.loader = retriever.loader();
        this.isInFavoritesState = false;
        this.isYourBetModeEnabled = false;
        this.dateFormat = retriever.dataProvider.shortDateFormat;
        this.timeFormat = retriever.dataProvider.shortTimeFormat;
        this.useMonthName = retriever.dataProvider.useMonthName;
        this.filterManager = retriever.filterManager;
        this.activeEventId = "";
        this.activeMarketId = "";
        this.betslipItems = observable.map({});
        this.onLogin = this.onLogin.bind(this);
        this.favoritesManager = favoritesManager || new FavoritesManager(`favoriteEvents_${parserCmsConfig.topicPrefix}`);
        this.oddStyle = 0;
        this.timeZone = 0;
        this.mapEventLinkUrl = mapLinkUrl.bind(this, navFunctions.adjustLivePath, navFunctions.adjustSportsPath);
        this.mapLeagueLinkUrl = mapLeagueUrl.bind(this, navFunctions.adjustSportsPath);
        this.mapStatisticsIcon = mapStatisticsIcon.bind(this, parserCmsConfig.showStatisticsIcon);
        this.mapMBNMarketIcon = mapMBNMarketIcon.bind(this, parserCmsConfig.isMBNEnabled);
        this.specialLeagues = specialLeagues;
        this.hasSettlementDate = parserCmsConfig.hasSettlementDate;
        this.sortIPTopLeaguesFirst = parserCmsConfig.sortIPTopLeaguesFirst;
        this.messageBus = new MessageBus(this.topicPrefix, this);
        this.shouldSortEventsByTime = parserCmsConfig.shouldSortEventsByTime;
        this.outrightSelectionSorter = new OutrightSelectionSorter(parserCmsConfig.outrightSortOptions);
        this.piper.appendAll(["mapGameScore", "mapGamePart", "mapEventIcons", "mapParticipants", "mapTeamNames", "mapStatistics", "mapKickOffState", "mapAggregatedEventsCount", "mapGameTime", "filterExpiredOutrights"]);
        this.shouldSortEventsByTime && this.piper.append("sortEventsByTime");
    }
    get isMiniEventCard() {
        return this.retriever.isMiniEventCard;
    }
    ;
    get allEventsLoaded() {
        return this.retriever.allEventsLoaded;
    }
    ;
    /**
     * Base functions
     */
    activate() {
        this.messageBus.attachListeners();
        this.attachAllObservables();
        this.retriever.activate();
        this.isFavoritesEnabled && this.favoritesManager.loadFavorites();
        this.messageBus.requestGlobalListeners(this.timeZoneChange.bind(this), this.oddStyleChange.bind(this), this.onLogin.bind(this));
        this.messageBus.sendBsUtilStatusMessage();
    }
    deactivate() {
        this.sports = [];
        this.retriever.deactivate();
        this.dettachAllObservables();
        this.messageBus.dettachListeners();
        this.clearData();
    }
    setParams(sportIds) {
        this.sports = sportIds;
        this.dateRange = undefined;
        this.retriever.setParams(sportIds);
    }
    /**
     *  Attach/dettach observers to data
     */
    // TODO: observe only what is shown on the screen
    attachEventObservables() {
        this.eventsDisposers = [
            this.retriever.data.events.observe(this.eventsObserver),
            this.retriever.data.markets.observe(this.marketsObserver)
        ];
        //this.eventsDisposers.push.apply([...this.retriever.data.markets.values()].map(x => observe(x, this.marketsObserver)))
    }
    dettachEventObservables() {
        this.eventsDisposers.forEach(x => typeof x === "function" && x());
        this.eventsDisposers = [];
    }
    attachAllObservables() {
        this.attachEventObservables();
        Object.keys(this.retriever.subLoaders).forEach(type => {
            this.loaderDisposers.push(observe(this.retriever.subLoaders[type], this.updateLoader));
        });
    }
    dettachAllObservables() {
        this.loaderDisposers.forEach(x => typeof x === "function" && x());
        this.loaderDisposers = [];
        this.dettachEventObservables();
    }
    eventsEnhancments(events) {
        return this.mapEvents(this.piper.executePipeline(this.filterEvents(events)));
    }
    marketEnhancments(newMarkets) {
        const markets = newMarkets.map(m => {
            return Object.assign(Object.assign({}, m), {
                selections: m.selections.slice().map(x => (Object.assign({}, x))),
                tags: m.tags.slice()
            });
        });
        const cardConfig = this.retriever.cardConfig.getConfig(this.isMiniEventCard);
        const marketsFiltered = prepareMarkets(this.filterMarkets(markets), cardConfig, this.specialLeagues, this.events, this.outrightSelectionSorter);
        return this.mapMarkets(marketsFiltered);
    }
    get leagues() {
        const regions = this.retriever.activeRequests.fixtures ?
            this.retriever.activeRequests.fixtures.request.regionIds :
            (this.retriever.activeRequests.outrights ? this.retriever.activeRequests.outrights.request.regionIds : []);
        const leagues = this.retriever.leagues.map(x => {
            const league = Object.assign({}, x);
            if (this.sortIPTopLeaguesFirst) {
                let isFromRegion = regions && regions.indexOf(league.regionId) >= 0;
                updateLeagueRankID(league, isFromRegion);
            }
            this.mapLeagueLinkUrl(league);
            return league;
        });
        let topLeagues = [];
        let notTopLeagues = [];
        leagues.forEach(league => {
            if (league.isTopLeague || regions && regions.indexOf(league.regionId) >= 0) {
                topLeagues.push(league);
            }
            else {
                notTopLeagues.push(league);
            }
        });
        return topLeagues.sort(sortLeagues).concat(notTopLeagues.sort(sortLeagues));
    }
    getEventMode(event) {
        let isOutright = event.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString();
        if (event.isLive) {
            return isOutright ? EventModes.LiveOutright : EventModes.LiveFixture;
        }
        else {
            return isOutright ? EventModes.Outright : EventModes.Fixture;
        }
    }
    /**
     * Internal msg bus handlers
     */
    sportsChange(x) {
        if (!this.isInFavoritesState && compareArrays(x.sportIds, this.sports)) {
            return;
        }
        this.isInFavoritesState = false;
        this.sports = x.sportIds;
        this.setSubFilterPredicate(SubFilterPredicate.None);
        this.retriever.querySportUpdate(x.sportIds);
        this.events = this.eventsEnhancments([...this.retriever.data.events.values()]);
        //personalized highlight (for you tab) should reset data
        if (x.sportIds.length > 1) {
            this.retriever.loadedData.clearData();
        }
    }
    leaguesChange(x) {
        this.isInFavoritesState = false;
        this.sports = [x.sportId];
        this.retriever.clearData();
        this.clearData();
        this.retriever.queryLeaguesUpdate(x.leagueIds, this.sports);
    }
    regionsChange(x) {
        this.isInFavoritesState = false;
        this.sports = [x.sportId];
        this.retriever.queryRegionIdUpdate(x.regionId, x.sportId);
    }
    datesChange(x) {
        var _a, _b, _c, _d;
        if (((_a = x.dateRange.from) === null || _a === void 0 ? void 0 : _a.getTime()) !== ((_c = (_b = this.dateRange) === null || _b === void 0 ? void 0 : _b.from) === null || _c === void 0 ? void 0 : _c.getTime()) || x.dateRange.timeRange !== ((_d = this.dateRange) === null || _d === void 0 ? void 0 : _d.timeRange)) {
            this.isInFavoritesState = false;
            this.dateRange = x.dateRange;
            this.events = this.eventsEnhancments([...this.retriever.data.events.values()]);
            this.retriever.queryDatesUpdate(this.dateRange, this.sports);
        }
        if (x.fixturesCount) {
            this.eventsCountBySport[this.sports[0]] = x.fixturesCount;
        }
    }
    liveStreamChange() {
        if (this.filterManager.isCurrentMainFilter(FilterPredicate.LiveStreaming)) {
            return;
        }
        this.isInFavoritesState = false;
        this.sports = this.allSportIds;
        this.dateRange = undefined;
        this.retriever.queryTagsUpdate(EventsBySportIdRequest.EventTagsEnum.LiveStreaming);
        this.events = this.eventsEnhancments([...this.retriever.data.events.values()]);
    }
    favoritesChange() {
        if (this.filterManager.isCurrentMainFilter(FilterPredicate.Favorites)) {
            return;
        }
        this.isInFavoritesState = true;
        this.sports = this.favoritesManager.favoriteSportIds;
        this.dateRange = undefined;
        this.retriever.queryFavoritesUpdate(this.favoritesManager.getFavorites);
    }
    liveStreamingChange() {
        this.setSubFilterPredicate(SubFilterPredicate.LiveStreaming);
        this.events = this.eventsEnhancments([...this.retriever.data.events.values()]);
    }
    fastMarketsChange() {
        this.setSubFilterPredicate(SubFilterPredicate.FastMarket);
        this.events = this.eventsEnhancments([...this.retriever.data.events.values()]);
    }
    allEventsChange() {
        this.setSubFilterPredicate(SubFilterPredicate.None);
        this.events = this.eventsEnhancments([...this.retriever.data.events.values()]);
    }
    yourBetSwitchChange(msg) {
        this.isYourBetModeEnabled = msg.isYourBetModeEnabled;
    }
    marketGroupsChange(msg) {
        if (this.activeMarketId === msg.marketId) {
            return;
        }
        this.dettachEventObservables();
        this.activeMarketId = msg.marketId;
        this.markets = this.marketEnhancments([...this.retriever.data.markets.values()]);
        this.attachEventObservables();
    }
    activeEventIdChange(eventId) {
        if (!eventId) {
            return;
        }
        this.activeEventId = eventId;
    }
    onLogin(user) {
        user && this.retriever.setRegionId(user.CountryOfRegistration);
    }
    onLogout() {
        this.retriever.removeRegionId();
    }
    renewJWTToken() {
        this.retriever.renewJWTToken();
    }
    updateMiniEventCard(isMiniEventCard) {
        this.retriever.isMiniEventCard = isMiniEventCard;
    }
    changedToSide(eventCardMessage) {
        this.updateMiniEventCard(eventCardMessage.changedToSide);
        if (!eventCardMessage.changedToSide) {
            this.filterManager.setSubPredicate(SubFilterPredicate.None);
            this.events = this.eventsEnhancments([...this.retriever.data.events.values()]);
        }
        this.events = this.events.map(event => {
            mapEventComponent(event, this.retriever.cardConfig, this.isMiniEventCard);
            mapIsSelected(event, this.activeEventId);
            return event;
        });
        if (eventCardMessage.initActiveEvent && !this.activeEventId && this.events.length) {
            const firstEvent = this.events[0];
            const isOutright = firstEvent.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString();
            this.activeEventId = firstEvent.id;
            this.messageBus.sendActiveEventMessage(this.activeEventId, isOutright);
        }
        let activeEvent = this.events.find(e => e.id === this.activeEventId);
        if (activeEvent) {
            this.messageBus.sendLastActiveEventMessage(activeEvent.id, this.getEventMode(activeEvent));
        }
        this.sendTagsMessage(this.events);
    }
    betslipAddedItemsReceived(message) {
        this.dettachEventObservables();
        message.items.forEach((item) => {
            let market = this.markets.find(m => m.id === item.marketId);
            let selection = market && market.selections.find(s => s.id === item.selectionId);
            this.betslipItems.set(`${item.marketId}_${item.selectionId}`, true);
            if (selection) {
                selection.isSelectionInBetslip = true;
            }
        });
        this.attachEventObservables();
    }
    betslipRemovedItemsReceived(message) {
        this.dettachEventObservables();
        message.items.forEach((item) => {
            let market = this.markets.find(m => m.id === item.marketId);
            let selection = market && market.selections.find(s => s.id === item.selectionId);
            this.betslipItems.set(`${item.marketId}_${item.selectionId}`, false);
            if (selection) {
                selection.isSelectionInBetslip = false;
            }
        });
        this.attachEventObservables();
    }
    betslipClearedItemsReceived() {
        this.dettachEventObservables();
        this.betslipItems.clear();
        this.attachEventObservables();
    }
    betSlipStatusReceived(message) {
        this.dettachEventObservables();
        this.betslipItems.clear();
        message.items.forEach((item) => {
            let market = this.markets.find(m => m.id === item.marketId);
            let selection = market && market.selections.find(s => s.id === item.selectionId);
            this.betslipItems.set(`${item.marketId}_${item.selectionId}`, true);
            if (selection) {
                selection.isSelectionInBetslip = true;
            }
        });
        this.attachEventObservables();
    }
    oddStyleChange(oddStyleMsg) {
        this.oddStyle = oddStyleMsg.currentSelectedOddStyle;
        this.markets.forEach(market => {
            market.selections = mapSelectionsOdds(market.selections, this.oddStyle, this.dict);
        });
    }
    timeZoneChange(timeZoneMsg) {
        this.timeZone = timeZoneMsg.currentSelectedTimeZone;
    }
    mapEvents(events) {
        return events.map((ev) => {
            // add events missing properties
            mapKickOffTime(ev, this.timeZone);
            mapStartDateTime(ev, {
                currentTimeZone: this.timeZone,
                dateFormat: this.dateFormat,
                timeFormat: this.timeFormat,
                useMonthName: this.useMonthName,
                dict: this.dict,
                hasSettlementDate: this.hasSettlementDate
            });
            mapIsSelected(ev, this.activeEventId);
            this.mapEventLinkUrl(ev);
            this.isFavoritesEnabled && (ev.isInFavorites = this.favoritesManager.isInFavorites(ev.id));
            mapEventComponent(ev, this.retriever.cardConfig, this.isMiniEventCard);
            this.mapStatisticsIcon(ev);
            return ev;
        });
    }
    mapMarkets(updatedMarkets) {
        return updatedMarkets.map(m => {
            let sel = mapSelectionsOdds(m.selections, this.oddStyle, this.dict);
            m.selections = sel;
            this.addSelectionBetslipStatusProperty(m);
            this.mapMBNMarketIcon(m);
            return m;
        });
    }
    updateLoader() {
        this.loader = this.retriever.loader();
        if (!this.loader.isLoading && this.loader.isFullLoadFinished) {
            const filteredEvents = this.filterEvents([...this.retriever.data.events.values()]);
            this.sendEventsCountMessage(this.eventsCountBySport[this.sports[0]] || filteredEvents.length);
            this.sendTagsMessage(filteredEvents);
            this.messageBus.sendBsUtilStatusMessage();
        }
    }
    eventsListCountChange(msg) {
        this.eventsCountBySport[msg.sportId] = msg.eventsCount;
    }
    managedEvents(events) {
        let filteredEvents = this.filterEvents(events);
        let eventsToUpdate = this.mapEvents(this.piper.executePipeline(filteredEvents));
        return eventsToUpdate;
    }
    addSelectionBetslipStatusProperty(market) {
        market.selections = market.selections.map((selection) => {
            const selectionId = `${selection.marketId}_${selection.id}`;
            extendObservable(selection, {
                isSelectionInBetslip: this.betslipItems.get(selectionId) || false
            });
            return selection;
        });
    }
    /**
     * Filter data collections
     */
    filterEvents(events) {
        let to = this.dateRange && this.dateRange.from ? DateRangeMapper[this.dateRange.timeRange](this.dateRange.from) : "";
        let ids = this.filterManager.getMainPredicate() === FilterPredicate.Favorites ? this.favoritesManager.favoriteEventIds : this.sports;
        let filterFn = this.filterManager.filterEntity.bind(this.filterManager, ids, this.dateRange && this.dateRange.from, to);
        let filteredEvents = events.filter(filterFn);
        return filteredEvents.map(x => (Object.assign({}, x)));
    }
    filterMarkets(markets) {
        // activeMarketId is being set to -1, when no filtration should be applied
        if (!this.activeMarketId || this.activeMarketId === "-1") {
            return markets;
        }
        return markets.filter(this.retriever.filterByMarketId.bind(this.retriever, this.activeMarketId));
    }
    setSubFilterPredicate(newFilter) {
        if (this.filterManager.isCurrentSubFilter(newFilter)) {
            return;
        }
        this.isInFavoritesState = false;
        this.dateRange = undefined;
        this.filterManager.setSubPredicate(newFilter);
    }
    /**
     * Send messages via msg bus
     */
    sendEventsCountMessage(count) {
        let sport = this.filterManager.getMainPredicate() === FilterPredicate.LiveStreaming || this.sports.length === 0 ?
            StreamingFilterBlockConstant : this.sports[0];
        this.messageBus.sendEventCountMessage(count, sport);
    }
    sendTagsMessage(events) {
        let hasLiveStreamEvents = false;
        let hasFastMarketsEvents = false;
        for (let i = 0; i < events.length; i += 1) {
            const ev = events[i];
            ev.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.LiveStreaming.toString()) > -1 && (hasLiveStreamEvents = true);
            ev.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.FastMarket.toString()) > -1 && (hasFastMarketsEvents = true);
            if (hasLiveStreamEvents && hasFastMarketsEvents) {
                break;
            }
        }
        const result = { hasLiveStreamEvents, hasFastMarketsEvents };
        this.messageBus.sendTagsMessage(result);
        return result;
    }
    sendBsUtilItemsAddMessage(items) {
        this.messageBus.sendBsUtilItemsAddMessage({ items, receiverIds: [] });
    }
    sendBsUtilItemsRemoveMessage(items) {
        this.messageBus.sendBsUtilItemsRemoveMessage({ items, receiverIds: [] });
    }
    /**
     * Handlers triggered from State
     */
    manageFavorites(event) {
        event.isInFavorites = !event.isInFavorites;
        this.favoritesManager.manageFavorites(event);
    }
    getOpenGameData(event, ev) {
        if (!event) {
            return;
        }
        return {
            event: ev,
            id: parseInt(event.id),
            isLive: event.isLive,
            evTypeForGameBlock: this.getEventMode(event),
            shouldHideSidePanels: false,
            branchID: parseInt(event.sportId)
        };
    }
    openStats(statisticsEventId, e) {
        let statData = this.getStatisticsData(statisticsEventId);
        this.retriever.dataProvider.statisticsProvider.openStats(statData, e);
    }
    openLiveStream(eventId) {
        this.messageBus.sendLiveStreamMessage(eventId);
    }
    getStatisticsData(statisticsEventId) {
        return Object.assign(Object.assign({}, EmptyStatisticsData), { betRadarData: {
                clientId: this.clientId,
                eventId: statisticsEventId
            } });
    }
    eventsObserver(change) {
        if (change.type === "add") {
            const event = this.eventsEnhancments([change.newValue])[0];
            if (event) {
                this.events.push(event);
            }
        }
        if (change.type === "delete") {
            const indexToDelete = this.events.findIndex(e => e.id === change.oldValue.id);
            this.events.splice(indexToDelete, 1);
        }
        if (change.type === "update") {
            const event = this.eventsEnhancments([change.newValue])[0];
            if (event) {
                const indexToUpdate = this.events.findIndex(e => e.id === change.newValue.id);
                this.events[indexToUpdate] = event;
            }
        }
    }
    marketsObserver(change) {
        this.dettachAllObservables();
        if (change.type === "add") {
            const marketToAdd = this.marketEnhancments([change.newValue])[0];
            if (marketToAdd) {
                this.markets.push(marketToAdd);
            }
        }
        if (change.type === "delete") {
            const indexToDelete = this.markets.findIndex(e => e.id === change.oldValue.id);
            this.markets.splice(indexToDelete, 1);
        }
        if (change.type === "update") {
            const indexToUpdate = this.markets.findIndex(e => e.id === change.newValue.id);
            this.markets[indexToUpdate] = this.marketEnhancments([change.newValue])[0];
        }
        this.attachAllObservables();
    }
    /**
     * Store retrieved data helpers
     */
    getCardConfigBySportId(id, isMiniEventCard) {
        return this.retriever.cardConfig.getCardConfigBySportId(id, isMiniEventCard);
    }
    viewMore() {
        this.retriever.loadMoreData();
    }
    clearData() {
        this.dateRange = undefined;
        this.events = observable([]);
        this.markets = observable([]);
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "events", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "markets", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "eventsCountBySport", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Parser.prototype, "sports", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "dateRange", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Parser.prototype, "oddStyle", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], Parser.prototype, "timeZone", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Parser.prototype, "isInFavoritesState", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "loader", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Parser.prototype, "isYourBetModeEnabled", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], Parser.prototype, "activeEventId", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], Parser.prototype, "activeMarketId", void 0);
__decorate([
    observable,
    __metadata("design:type", ObservableMap)
], Parser.prototype, "betslipItems", void 0);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Parser.prototype, "isMiniEventCard", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Parser.prototype, "allEventsLoaded", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "activate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "deactivate", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Parser.prototype, "leagues", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "sportsChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "leaguesChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "regionsChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "datesChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "liveStreamChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "favoritesChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "liveStreamingChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "fastMarketsChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "allEventsChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "yourBetSwitchChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "marketGroupsChange", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "activeEventIdChange", null);
__decorate([
    Debounce,
    __metadata("design:type", Object)
], Parser.prototype, 249, void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "changedToSide", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "betslipAddedItemsReceived", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "betslipRemovedItemsReceived", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "betslipClearedItemsReceived", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "betSlipStatusReceived", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "oddStyleChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "timeZoneChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "mapEvents", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "mapMarkets", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateLoader", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "eventsListCountChange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "manageFavorites", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "eventsObserver", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "marketsObserver", null);
//# sourceMappingURL=parser.js.map